import { CaseFlagModel } from './caseFlagModel';

export class CaseFlagEditModel extends CaseFlagModel{
}
